/* eslint-disable */
import axios from "axios";
export const uploadImagePolyfill = (function() {
  const ua = navigator.userAgent;
  const isAndroid = Boolean(navigator.userAgent.match(/android/gi));
  const isAndroidDict = isAndroid && Boolean(/dict/gi.test(ua) && !/trans/gi.test(ua));
  let id = 1;
  return function(options) {
    options = options || {};
    return new Promise((resolve, reject) => {
      if (!isAndroidDict) {
        const inputUid = "_yd_activity_input_file_" + id;
        const inputFile = document.getElementById(inputUid) || document.createElement("input");
        if (!inputFile.id) {
          document.body.appendChild(inputFile);
          inputFile.id = inputUid + id++;
          setAttribute(inputFile, options);
        } else {
          inputFile.value = "";
        }
        inputFile.addEventListener("change", e => {
          options.change && options.change(e);
          const files = (e.target && e.target.files) || [];
          const promises = [];
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const localUrl = URL.createObjectURL(file);
            const image = new Image();
            promises.push(
              new Promise((resolve, reject) => {
                image.addEventListener("load", () => {
                  const formData = new FormData();
                  formData.append("file", file);
                  formData.append("product", "dict");
                  formData.append("useCdn", true);
                  formData.append("useHttps", true);
                  axios.post("https://luna-nos.youdao.com/front/upload", formData).then(res => {
                    resolve({
                      url: res.url,
                      localUrl: localUrl
                    });
                  });
                });
                image.addEventListener("error", reject);
              })
            );
            image.src = localUrl;
            Promise.all(promises)
              .then(resolve)
              .catch(reject);
            inputFile.remove();
          }
        });
        inputFile.addEventListener("error", reject);
        setTimeout(() => {
          inputFile.click();
        });
      } else {
        const YDK = window.ydk;
        if (YDK) {
          YDK.config({
            jsApiList: ["chooseImage", "uploadImage"]
          });
          YDK.chooseImage({
            success: function(re) {
              options.change && options.change(re);
              Promise.all(
                re.localIds.map(v => {
                  return new Promise((resolve, reject) => {
                    YDK.uploadImage({
                      localId: v,
                      success: function(res) {
                        resolve({
                          url: res.serverId.replace(/http/, "https"),
                          localUrl: res.serverId.replace(/http/, "https")
                        });
                      },
                      fail: reject
                    });
                  });
                })
              )
                .then(res => {
                  resolve(res);
                })
                .catch(reject);
            },
            fail: reject
          });
        } else {
          reject("YDK is not defined");
        }
      }
    });
  };
  function setAttribute(input_file, options) {
    if (options.multiple) {
      input_file.setAttribute("multiple", "");
    }
    input_file.setAttribute("type", "file");
    input_file.setAttribute("hidden", "");
    input_file.setAttribute("accept", "image/*");
  }
})();